/**
 * voice-v8 — Stabile Identität eines Selbst-Vorschlags.
 *
 * Reine Funktion, keine Server- oder DOM-Imports — Frontend und Server
 * teilen sich dieselbe Wahrheit.
 *
 * WARUM: Der nächtliche Lauf legt für jedes Log-Muster ein Ticket
 * „Vorschlag: Wiederkehrender Fehler: <Muster>" an. Auf dem Telefon
 * fällt das Muster als Labor weg — drei Karten heißen gleich.
 * Ein wiederkehrender Fehler ist EIN Fund, nicht drei.
 */

export function vorschlagIdentitaet(titel: string): string {
  const t = titel.replace(/\s+/g, " ").trim().toLowerCase();
  if (/(?:^vorschlag:\s*)?wiederkehrender fehler\b/.test(t)) {
    return "vorschlag: wiederkehrender fehler";
  }
  return t;
}
